module.exports = __webpack_public_path__ + "img/people-location.619097d2.svg";